export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/sleep-blueberry.4c08b7b0b460cc7a3bc9f6ddf7107552.png";